import { render } from "./HumanResources.vue?vue&type=template&id=669e291c&scoped=true"
import script from "./HumanResources.vue?vue&type=script&lang=js"
export * from "./HumanResources.vue?vue&type=script&lang=js"

import "./HumanResources.vue?vue&type=style&index=0&id=669e291c&scoped=true&lang=css"

import exportComponent from "E:\\ismailDosyalar\\gifSites2\\gifSites\\2022\\gesas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669e291c"]])

export default __exports__